import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;

  h1 {
    text-align: center;
  }
`;
